// frontend/src/components/Shared/Button/Button.js

import React from 'react';
import './Button.css'; // Skapa en CSS-fil för gemensamma stilar

const Button = ({ onClick, children, className, style, ...props }) => {
  return (
    <button
      onClick={onClick}
      className={`shared-button ${className}`}
      style={style}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
